import JobSettings from "./JobSettings";
import {JOB_STATE_DRAFT, JOB_STATE_COMPLETE, JOB_COMPLETED_STATES} from "../const/job.const";
import JobFeedback from "./JobFeedback";
import JobThumbnails from "./JobThumbnails";
import {createUUID4} from "../../../../../helper/uuid";

export default class Job {
    id = '';
    apiJob = null;
    base64_output_images = [];
    settings = {};
    state = JOB_STATE_DRAFT;
    zipJob = null;
    selectedOutputs = [];
    feedback = {};
    thumbnails = {};

    constructor() {
        this.id = createUUID4();
        this.settings = new JobSettings();
        this.feedback = new JobFeedback();
        this.thumbnails = new JobThumbnails();
    }

    isStateCompleted() {
        return JOB_COMPLETED_STATES.includes(this.state);
    }
}
